import { format } from '../../shared/utils/string.util';
import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.eventHubsLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.EventHubs_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.EventHubs_DisplayText)
    ]
})
export class EventHubsLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static NAMESPACE_NAME: IAttribute;
    public static ACCESS_KEY_NAME: IAttribute;
    public static ACCESS_KEY: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_EventHubs_Namespace_DisplayText,
        templatable: true,
        association: 'NAMESPACE_NAME'
    })
    public namespaceName: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_EventHubs_PolicyName_DisplayText,
        templatable: true,
        association: 'ACCESS_KEY_NAME'
    })
    public accessKeyName: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_EventHubs_PolicyKey_DisplayText,
        templatable: true,
        association: 'ACCESS_KEY'
    })
    public accessKey: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
